
<form #form="ngForm" autocomplete="off" (ngSubmit)="submit()" class="search-bar" style="padding-top: 20px; padding-bottom: 20px">
  <div class="input-group">
    <span class="input-group-text">
      <i class="fas fa-search"></i>
    </span>
    <input [(ngModel)]="searchText" autocomplete="off" (ngModelChange)="searchEvent($event)" name="search" type="text" class="form-control" placeholder="Search Website" aria-label="Search Col" aria-describedby="addon-wrapping">
    <span (click)="searchText = ''" class="input-group-text" id="basic-addon2">
      <i class="fas fa-times"></i>
    </span>
  </div>
</form>

<div id="" *ngIf="searchText" class="row m-3">
  <p>{{'Search.Results' | translate}} {{searchText}}</p>
  <hr>
</div>

<div class="row searchBox px-4">
  <div *ngFor="let item of queries" class="col-12 searchBox--item">
    <a routerLink="{{item.url}}">
      <h3 class="searchBox--header">{{item.title + '.SearchTitle' | translate}}</h3>
      <p class="searchBox--link">https://assessor.lacounty.gov{{item.url}}</p>
      <p class="searchBox--text">{{item.title + '.SearchDescription' | translate}}</p>
    </a>
    <hr>
  </div>

</div>
